import { SaleTransactionType } from 'api-hooks/refund/refund';
import { NavigationRoutes } from 'common/constants';
import notification from 'components/common/notification';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import AgentSelectInput from 'legacy-modules/master/agent/components/select-input';
import PaymentChannelSelectInput from 'legacy-modules/master/payment-channel/components/select-input';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

export default function AgentDetailField() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const { getValues } = useFormContext();

  const onItemInvoked = React.useCallback(() => {
    const id = getValues('purchase.id');
    const transactionType = getValues('purchase.transactionType');

    let target = '';

    switch (transactionType) {
      case SaleTransactionType.ACTIVITY:
        target = NavigationRoutes.ActivityPurchasesView;
        break;
      case SaleTransactionType.CRUISE:
        target = NavigationRoutes.CruisePurchasesView;
        break;
      case SaleTransactionType.DOCUMENT:
        target = NavigationRoutes.DocumentPurchasesView;
        break;
      case SaleTransactionType.FLIGHT:
        target = NavigationRoutes.FlightPurchasesView;
        break;
      case SaleTransactionType.HOTEL:
        target = NavigationRoutes.HotelPurchasesView;
        break;
      case SaleTransactionType.PRODUCT:
        target = NavigationRoutes.ProductPurchasesView;
        break;
      default:
        notification.error({
          message: t('refund:no_selected_extra', {
            extra: t('common:invoice_number'),
          }),
        });
        return <></>;
    }

    navigate(target as NavigationRoutes, {
      id,
    });
  }, [getValues, navigate, t]);

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <FullContainer>
        <SectionContainer $style={{ alignItem: 'center' }}>
          <div style={{ flex: 1 }}>
            <Text variant="HeadingXSmall">{t('common:purchase_details')}</Text>
          </div>
          <SeparatorVertical $margin={8} />
          <Button onClick={onItemInvoked} buttonType="secondary">
            {t('common:view_detail')}
          </Button>
        </SectionContainer>
        <SeparatorVertical $margin={36} />

        <SectionContainer>
          <HalfContainer>
            <Input
              type="date-time"
              name="purchase.transactionAt"
              label={t('common:transaction_at')}
              placeholder={t('common:transaction_at')}
              disabled
            />
          </HalfContainer>
          <HalfContainer>
            <Input
              type="number"
              name="purchase.total"
              label={t('common:total')}
              placeholder={t('common:total')}
              disabled
            />
          </HalfContainer>
        </SectionContainer>
        <SectionContainer>
          <HalfContainer>
            <AgentSelectInput name="purchase.agentId" disabled />
          </HalfContainer>
          <HalfContainer>
            <PaymentChannelSelectInput
              name="purchase.paymentChannelId"
              disabled
            />
          </HalfContainer>
        </SectionContainer>
      </FullContainer>
    </CardSection>
  );
}
